import React, { useState, useContext } from 'react';
// import axios from 'axios';
import { AuthContext } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { authAPI } from '../../services/api';

const ChangePassword = () => {
  const { currentUser } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset message
    setMessage({ type: '', text: '' });
    
    // Trim all password fields
    const trimmedData = {
      currentPassword: formData.currentPassword.trim(),
      newPassword: formData.newPassword.trim(),
      confirmPassword: formData.confirmPassword.trim()
    };

    // Check for blank spaces in passwords
    if (formData.currentPassword.includes(' ') || 
        formData.newPassword.includes(' ') || 
        formData.confirmPassword.includes(' ')) {
      setMessage({ type: 'danger', text: 'Passwords cannot contain blank spaces.' });
      return;
    }
    
    // Validate passwords match
    if (trimmedData.newPassword !== trimmedData.confirmPassword) {
      setMessage({ type: 'danger', text: 'Confirmation password does not match the new password.' });
      return;
    }
    
    // Validate password strength
    if (trimmedData.newPassword.length < 8) {
      setMessage({ type: 'danger', text: 'Password must be at least 8 characters long.' });
      return;
    }
    
    setLoading(true);
    
    try { 
      const response = await authAPI.changePassword(
        trimmedData.currentPassword,
        trimmedData.newPassword
      ); 
      
      // Check if it's a mock implementation or real response
      if (response.data.message && response.data.message.includes('mock')) { 
        // Handle mock implementation success
        setMessage({ 
          type: 'success', 
          text: 'Password changed successfully! (Using mock implementation due to server connectivity issues)' 
        });
      } else {
        // Handle real implementation success
        setMessage({ 
          type: 'success', 
          text: 'Password changed successfully!' 
        });
      }
      
      // Clear form
      setFormData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    } catch (error) {
      console.error('Error changing password:', error);
      
      // Detailed error handling
      if (error.response) {
        // Server responded with an error
        const status = error.response.status;
        const errorMsg = error.response.data?.message || 'Unknown server error';
        
        if (status === 400) {
          setMessage({ type: 'danger', text: 'Current password is incorrect.' });
        } else if (status === 404) {
          setMessage({ type: 'danger', text: 'Password change endpoint not found. Server might be misconfigured.' });
        } else {
          setMessage({ type: 'danger', text: `Server error (${status}): ${errorMsg}` });
        }
      } else if (error.request) {
        // Request was made but no response received (network error)
        setMessage({ 
          type: 'danger', 
          text: 'Network error: Could not connect to server. Please check your internet connection.' 
        });
      } else {
        // Something else caused the error
        setMessage({ 
          type: 'danger', 
          text: `Error: ${error.message}` 
        });
      }
    } finally {
      setLoading(false);
    }
  };

  if (!currentUser) {
    return (
      <div className="container mt-4">
        <div className="alert alert-warning">
          <i className="fas fa-exclamation-triangle me-2"></i>
          Please log in to change your password.
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className="card shadow">
            <div className="card-header text-white">
              <h3 className="mb-0">
                <i className="fas fa-key me-2"></i>
                Change Password
              </h3>
            </div>
            <div className="card-body">
              {message.text && (
                <div 
                  className={`alert alert-${message.type}`}
                >
                  {message.type === 'success' ? (
                    <i className="fas fa-check-circle me-2"></i>
                  ) : message.type === 'warning' ? (
                    <i className="fas fa-exclamation-triangle me-2"></i>
                  ) : (
                    <i className="fas fa-exclamation-circle me-2"></i>
                  )}
                  {message.text}
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="currentPassword" className="form-label">Current Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="currentPassword"
                    name="currentPassword"
                    value={formData.currentPassword}
                    onChange={handleInputChange}
                    
                  />
                </div>
                
                <div className="mb-3">
                  <label htmlFor="newPassword" className="form-label">New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="newPassword"
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleInputChange}
                    
                    minLength="8"
                  />
                  <small className="text-muted">Password must be at least 8 characters long.</small>
                </div>
                
                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label">Confirm New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    
                  />
                </div>
                
                <div className="d-flex justify-content-between flex-wrap">
                  <Link to="/profile" className="btn btn-secondary mb-2">
                    <i className="fas fa-arrow-left me-1"></i> Back to Profile
                  </Link>
                  <button 
                    type="submit" 
                    className="btn btn-primary mb-2" 
                    disabled={loading}
                    style={{marginBlockStart: '0'}}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Updating...
                      </>
                    ) : (
                      'Change Password'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword; 